import axios, { isCancel } from "axios";
import { logError, safeStringify } from "@/utils/errorHandler";
import { getTokenAccessor } from "@/lib/auth";

const CORE_BASE = import.meta.env.VITE_CORE_SERVICE_BASE_URL || "";
const X_TOKEN = import.meta.env.VITE_CORE_SERVICE_X_TOKEN || "";

export function createCoreServiceClient(
  basePath: string,
  clientLabel: string,
  withAuth = false
) {
  const api = axios.create({
    baseURL: `${CORE_BASE}${basePath}`,
    headers: {
      "Content-Type": "application/json",
      "X-Token": X_TOKEN,
    },
  });

  api.interceptors.request.use(
    (config) => {
      if (withAuth) {
        const token = getTokenAccessor();
        if (token) config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isCancel(error)) return Promise.reject(error);

      logError(
        error,
        `${clientLabel} API: ${error.config?.method?.toUpperCase() || "API"} ${
          error.config?.url || "unknown"
        }`
      );

      const rawMessage =
        error.response?.data?.message ||
        error.response?.data?.error_description ||
        error.message ||
        "An unexpected error occurred";

      return Promise.reject({
        ...error,
        message: safeStringify(rawMessage),
        status: error.response?.status,
      });
    }
  );

  return api;
}
